import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { encodeInitialValuesForImport } from 'src/components/GenerationTask/MultiColumnGenerationForm/importEncode'
import { useMyInfo } from 'src/services/apollo/auth'
import { joinURL, withQuery } from 'ufo'

/**
 * Returns a function that navigates to /generator with the given prompt
 * pre-filled. If the user is not logged in, shows the sign-up modal first.
 */
export function useNavigateToGenerator() {
  const navigate = useNavigate()
  const { data: userInfo } = useMyInfo()

  return useCallback(
    (prompts?: string) => {
      if (!prompts) {
        return navigate(
          userInfo
            ? '/generator'
            : withQuery('/generator', {
                showSignUpModal: 1,
                signupModalRedirect: joinURL(
                  window.location.origin,
                  'generator',
                ),
              }),
        )
      }

      const initialValues = encodeInitialValuesForImport({ prompts })

      if (!userInfo) {
        return navigate(
          withQuery('/generator', {
            showSignUpModal: 1,
            initialValues,
            signupModalRedirect: withQuery(
              joinURL(window.location.origin, 'generator'),
              { initialValues },
            ),
          }),
        )
      }

      return navigate(withQuery('/generator', { initialValues }))
    },
    [navigate, userInfo],
  )
}
